/* eslint-disable no-console */
// ************************************************************ PERSONAL IMPORTS
import { modelDbUser } from './model'

// ************************************************************ DEXIE IMPORTS
import Dexie from 'dexie'
import { logger } from 'src/shared/lib/logger/logger-manager'
import { IUserDatabase } from 'src/shared/interface/model.interface'

// ************************************************************ DATABASES NAMES
const dbUserName = process.env.FRONTEND.databasesName.dbUser

export class ClassDbUser extends Dexie {
  user: Dexie.Table<IUserDatabase, number>

  constructor() {
    super(dbUserName)

    // Versionning
    modelDbUser.forEach(currentModel => {
      this.version(currentModel.version)
        .stores(currentModel.schema)
        .upgrade(trans => {
          if (currentModel.upgradeFn) {
            return currentModel.upgradeFn(trans)
          } else {
            return null
          }
        })
    })

    // The following lines are needed for it to work across typescipt using babel-preset-typescript:
    this.user = this.table('user')

    // Dexie events
    this.on('blocked', function () {
      logger?.log('[Dexie] Database dbUser BLOQUED')
    })

    this.on('close', function () {
      logger?.log('[Dexie] Database dbUser CLOSED')
    })
  }

  /**
   * db recreate (needed if model has change in a new version of the application)
   */
  deleteDbUser() {
    logger?.log('start deleting dbUser')
    this.delete().then(() => {
      logger?.log('dbUser deleted')
    })
      .catch((err) => {
        logger?.error('Could not delete database dbUser - err :', err)
      })
  }

  async isEmpty() {
    return (await this.user.count()) === 0
  }

  async isNotEmpty() {
    return (await this.user.count()) > 0
  }
}

export const dbUser = new ClassDbUser()
